/**
 * Lamination Line 2 API — backed by the `lam2_readings` table via the
 * `/lam2` router.
 *
 * The endpoints themselves live in `lamLine.ts`: Lamination 1 now runs the
 * same TIA project on the same PLC family and is served by the same backend
 * router factory, so both lines are one client keyed by prefix. This module is
 * the Lam 2 instance of it, and keeps the `Lam2*` names its callers use.
 */
import { makeLamApi } from "./lamLine";
import type {
  LamGroupBy,
  LamSpeedRow,
  LamCurrentRow,
  LamStatusRow,
  LamCurrentStatus,
  LamShiftRollsRow,
  LamRollEvent,
} from "./lamLine";

export type Lam2GroupBy = LamGroupBy;
export type Lam2SpeedRow = LamSpeedRow;
export type Lam2CurrentRow = LamCurrentRow;
export type Lam2StatusRow = LamStatusRow;
export type Lam2CurrentStatus = LamCurrentStatus;
export type Lam2ShiftRollsRow = LamShiftRollsRow;
export type Lam2RollEvent = LamRollEvent;

/** This line's calls as one object, for components shared with the other line. */
export const lam2Api = makeLamApi("/lam2");
const lam2 = lam2Api;

export const getLam2ScrewSpeeds = lam2.getScrewSpeeds;
export const getLam2MotorCurrents = lam2.getMotorCurrents;
export const getLam2Status = lam2.getStatus;
export const getLam2CurrentStatus = lam2.getCurrentStatus;
export const getLam2ShiftRolls = lam2.getShiftRolls;
export const getLam2RollEvents = lam2.getRollEvents;
